export const EXPORT_FIELDS_TYPES = {
  FLOAT: 'FLOAT',
  INTEGER: 'INTEGER',
  DATE: 'DATE',
  STRING: 'STRING'
}
